export default __webpack_public_path__ + "static/media/Logo_Tablet.897b80cd.svg";